module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/users/user-list/user-list.component.css
// module id = ./src/app/users/user-list/user-list.component.css
// module chunks = main